// extracted by mini-css-extract-plugin
export default {"container":"Wmkz5","row":"twL+a","column":"VGeee","iconColumn":"CfLe-"};